module.exports = __webpack_public_path__ + "static/img/data-center-1.b277b7a8.png";